/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum KeyPhysicalType {
    MetresAdvanced = 0,
    TonnesFired = 1,
    TonnesBogged = 2,
    Fires = 3,
    Custom = 4,
}
